export const chart_global_Fill_Color_500 = {
  "name": "--pf-chart-global--Fill--Color--500",
  "value": "#8a8d90",
  "var": "var(--pf-chart-global--Fill--Color--500, #8a8d90)"
};
export default chart_global_Fill_Color_500;